import React, { useState, useEffect } from 'react';
import {
    Grid,
    Container,
    FormGroup,
    FormControlLabel,
    Switch,
    IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { DataGrid } from '@mui/x-data-grid';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import CustomDialogBox from '../../components/custom-dialog-box';
import useDialogBoxHook from '../../hooks/dialog-box-hook';
import useLiveMgtHook from '../../hooks/live-mgt-hook';

export default function LiveList() {

    const { live_list, actionChangeStatus, fetchLiveStream, actionDelete } = useLiveMgtHook()

    const {
        is_dialog_box_open,
        dialog_box_header,
        dialog_box_body,
        dialog_box_action,
        setDialogBoxOption
    } = useDialogBoxHook()

    const [selected_id, setSelectedId] = useState(0)
    const [selected_status, setSelectedStatus] = useState(false)

    const columns = [
        { field: 'index', headerName: 'ลำดับ', maxWidth: 50, flex: 1 },
        { field: 'streaming_name', headerName: 'ชื่อ Live', minWidth: 250, flex: 1 },
        {
            field: "status",
            headerName: "Activated",
            sortable: false,
            maxWidth: 150,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                size="small"
                                checked={cellValues.row.active}
                                onClick={(event) => {
                                    handleStatusSwitch(event, cellValues);
                                }}
                            />
                        }
                        label=""
                    />
                </FormGroup>
            }
        },
        {
            field: "edit",
            headerName: "Edit",
            sortable: false,
            maxWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={(event) => {
                        handleEditClick(event, cellValues);
                    }} >
                    <EditIcon />
                </IconButton>
            }
        },
        {
            field: "delete",
            headerName: "Delete",
            sortable: false,
            maxWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={(event) => {
                        handleDeleteClick(event, cellValues);
                    }} >
                    <DeleteIcon />
                </IconButton>
            }
        }
    ];

    const handleAddClick = (event) => {
        event.preventDefault();
        window.location.href = "/admin/live/add"
    }

    const handleEditClick = (event, cellValues) => {
        event.preventDefault();
        window.location.href = "/admin/live/edit/"+cellValues.row.id
    }

    const handleDeleteClick = (event, cellValues) => {
        event.preventDefault();
        let streaming_id = cellValues.row.id
        let streaming_name = cellValues.row.streaming_name
        setSelectedId(streaming_id)
        setDialogBoxOption(
            true,
            "ลบ Live Stream",
            "คุณต้องการลบช้อมูล Live Stream " + streaming_name + " หรือไม่",
            "delete"
        )

    }

    const handleStatusSwitch = (event, cellValues) => {
        event.preventDefault();
        let streaming_id = cellValues.row.id
        let streaming_name = cellValues.row.streaming_name
        let status = cellValues.row.active
        setSelectedId(streaming_id)
        setSelectedStatus(status)
        setDialogBoxOption(
            true,
            "เปลี่ยนสถานะ Live Stream",
            "คุณต้องการเปลี่ยนสถานะ Live Stream " + streaming_name + " หรือไม่",
            "change_status"
        )
    }

    const handleDialogClose = (event) => {
        setDialogBoxOption(
            false,
            "",
            "",
            ""
        )
        setSelectedId(0)
    }

    const handleSubmitButton = async () => {
        let result
        if (dialog_box_action === 'change_status') {
            result = await actionChangeStatus(selected_id, selected_status)
        } else if (dialog_box_action === 'delete') {
            result = await actionDelete(selected_id)
        }
        alert(result.msg)
        if (result.result) {
            fetchLiveStream()
            handleDialogClose()
        }
    }

    return (
        <>
            <AdminMenu />
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Live Stream Management"}
                    button_title={"Add Live Stream"}
                    handleBtnClick={handleAddClick}
                    is_main_page={true}
                />
                <Grid container>
                    <Grid item xs={12} >
                        <div style={{ height: 600, width: '100%', marginTop: '2rem' }}>
                            <DataGrid
                                style={{ backgroundColor: "#FFFFFF" }}
                                rows={live_list}
                                columns={columns}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Container>

            <CustomDialogBox
                open={is_dialog_box_open}
                handleCancleButton={handleDialogClose}
                header={dialog_box_header}
                body={dialog_box_body}
                handleSubmitButton={handleSubmitButton}
            />
        </>
    )
}